import React from 'react';
import { useNavigate } from 'react-router-dom';
import Config from '../../config.json';
import axios from 'axios';
import Styles from './SchoolDirectory.module.css';

function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function School({ school, authenticated = false, triggerRefresh, isFavorite }) {
    let navigate = useNavigate();

    const handleSchoolClick = () => {
        window.location = `${Config.STATIC_BASE_URL}/school/${school.schoolId}`;
    };

    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        if (authenticated) {
            if (isFavorite) {
                axios.post(`${Config.API_BASE_URL}/user/remove-favorite-school`, { schoolId: school.schoolId })
                    .then(res => { triggerRefresh(); })
                    .catch(error => { console.error(error); });
            } else {
                axios.post(`${Config.API_BASE_URL}/user/add-favorite-school`, { schoolId: school.schoolId })
                    .then(res => { triggerRefresh(); })
                    .catch(error => { console.error(error); });
            }
        } else {
            navigate('/register');
        }
    };

    return (
        <div className={Styles.Card}>
            <div className={Styles.MainContent}>
                <div className={Styles.CardHeader}>
                    {school.imageURL && (
                        <div className={Styles.SchoolLogo}>
                            <img src={school.imageURL} alt={`${school.title} logo`} />
                        </div>
                    )}
                    <div className={Styles.SchoolTitleArea}>
                        <h3 className={Styles.SchoolTitle} onClick={handleSchoolClick}>
                            {school.title}
                        </h3>
                        <div className={Styles.SchoolLocation}>
                            {school.schoolLocationCity}, {school.schoolLocationState}
                        </div>
                    </div>
                    <div className={Styles.FavoriteButton} onClick={handleFavoriteClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill={isFavorite ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                        </svg>
                    </div>
                </div>

                <div className={Styles.StatsRow}>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>GPA</div>
                        <div className={Styles.StatValue}>{school.avgGPA}</div>
                    </div>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>MCAT</div>
                        <div className={Styles.StatValue}>{school.avgMCAT === null && school.schoolLocationCountry === 'Canada' ? "No MCAT" : school.avgMCAT}</div>
                    </div>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>CLASS SIZE</div>
                        <div className={Styles.StatValue}>{school.mdAcceptances}</div>
                    </div>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>TUITION IS</div>
                        <div className={Styles.StatValue}>${formatNumberWithCommas(school.tuitionIS)}</div>
                    </div>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>TUITION OOS</div>
                        <div className={Styles.StatValue}>${formatNumberWithCommas(school.tuitionOOS)}</div>
                    </div>
                    <div className={Styles.StatItem}>
                        <div className={Styles.StatLabel}>COMPETITIVENESS</div>
                        <div className={Styles.StatValue}>{school.competitiveness.replace('Competitive', '').replace('ly', '')}</div>
                    </div>
                </div>

                <div className={Styles.BottomRow}>
                    <div className={Styles.TagsContainer}>
                        {school.acceptsOOS && <span className={Styles.Tag}>OOS</span>}
                        {school.acceptsCanadian && <span className={Styles.Tag}>CAN</span>}
                        {school.acceptsInternational && <span className={Styles.Tag}>INTL</span>}

                        {school.requiresCASPer && (
                            <span className={Styles.RequirementTag}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                                CASPer®
                            </span>
                        )}

                        {school.requiresAAMCPREview && (
                            <span className={Styles.RequirementTag}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                                AAMC PREview™
                            </span>
                        )}
                    </div>

                    <button className={Styles.ViewButton} onClick={handleSchoolClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        View Details
                    </button>
                </div>
            </div>
        </div>
    );
}

export default School;